import { Box } from "@mui/system";
import { useEffect } from "react";
import { alpha, useMediaQuery, useTheme } from "@mui/material";
import PinInput from "react-pin-input";

/**
 * Single responsive OTP input (previously rendered 4× per breakpoint).
 * Theme-aware: background/border/focus/text follow the palette so it works in
 * both light and dark mode.
 */
function CustomPinInput({ handleOnSubmit, setInputValue }) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const cb = (e) => {
      const pasted = (e.clipboardData.getData("text") || "")
        .replace(/\D/g, "")
        .slice(0, 6);
      if (pasted) setInputValue(pasted);
    };
    window.addEventListener("paste", cb);
    return () => window.removeEventListener("paste", cb);
  }, [setInputValue]);

  const box = isSmall
    ? { width: "42px", height: "50px", fontSize: "18px", margin: "0 4px" }
    : { width: "52px", height: "58px", fontSize: "22px", margin: "0 6px" };

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <PinInput
        focus
        length={6}
        initialValue=""
        type="numeric"
        inputMode="number"
        style={{
          padding: "2px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        inputStyle={{
          ...box,
          background: theme.palette.background.default,
          border: `1.5px solid ${alpha(theme.palette.text.primary, 0.23)}`,
          color: theme.palette.text.primary,
          borderRadius: "8px",
          transition: "border-color 0.2s ease",
        }}
        inputFocusStyle={{ borderColor: theme.palette.primary.main }}
        onChange={(value) => setInputValue(value)}
        onComplete={(value) => handleOnSubmit({ otp: value })}
        autoSelect={true}
        regexCriteria={/^[0-9]*$/}
      />
    </Box>
  );
}

export default CustomPinInput;
